import React, { useEffect } from 'react';
import './LoginSignup.css';




import LeftImage from '../../assets/images/RAMZ/bg2.png?ver=1';


import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from '../../global/theme';
import { GlobalStyles } from '../../global/global';
import { useDarkMode } from '../shared/Toggle/useDarkMode';
import * as actions from "../../store/actionTypes";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import * as Constants from '../../constants/Constants';
import ImagesSlider from '../ImagesSlider/ImagesSlider'

function AuthContainer(props) {
    const { t } = useTranslation();
    const [theme, componentMounted] = useDarkMode();

    /* componentDidMount */
    useEffect(() => {
        //console.log("AuthContainer Mounted");
    }, [])

    const themeMode = theme === 'light' ? lightTheme : darkTheme;
    if (theme === 'dark') {
        props.setDarkMode(true)
    } else {
        props.setDarkMode(false)
    }

    if (!componentMounted) {
        return <div />
    };

    let imageClass = "col-md-6 auth-left hidden-sm";
    let formClass = "col-md-6 col-sm-12 auth-right";
    let flexClass = "flex-row";
    let formDirection = "ltr";

    if (props.i18n.language === "ar") {
        flexClass = "flex-row-reverse";
        formDirection = "rtl";
    }

    // let logo = null;
    // if (props.i18n.language === "en") {
    //     if (localStorage.getItem(Constants.localStorageConstants.company_name) === "FIT") {
    //         logo = FitLogo
    //     } else {
    //         if (theme === 'dark') {
    //             logo = ShuaaLogoWhiteEnglish
    //         } else {
    //             logo = ShuaaLogoBlueEnglish
    //         }

    //     }
    // } else {
    //     if (localStorage.getItem(Constants.localStorageConstants.company_name) === "FIT") {
    //         logo = FitLogo
    //     } else {
    //         if (theme === 'dark') {
    //             logo = ShuaaLogoWhiteArabic
    //         } else {
    //             logo = ShuaaLogoBlueArabic
    //         }

    //     }
    // }

    return (
        <ThemeProvider theme={themeMode}>
            <>
                <GlobalStyles />
                {/* <h1>It's a {theme === 'light' ? 'light theme' : 'dark theme'}!</h1> */}
                <div className="AuthCont">
                    <div className={"row auth " + flexClass}>
                        {localStorage.getItem(Constants.localStorageConstants.company_name) === "ALRAMZ" ?
                            <div className={imageClass}>
                                <div className="vertical-center">
                                    <img
                                        src={LeftImage}
                                        height='100%'
                                        width='100%'
                                        style={{ maxWidth: "100%" }}
                                        alt=""
                                    />
                                    {/* <img
                                        className="center image-bottom logo-image"
                                        src={logo}
                                        style={{ width: "174px", height: "130px" }} alt=""
                                    /> */}
                                </div>
                            </div>

                            : null
                        }
                        <div className={formClass} style={{ direction: formDirection }}>
                            <div className="form-horizantal vertical-center">
                                {/* <img
                                    className="center logo-image"
                                    // src={logo}
                                    style={{ width: "174px", height: "130px" }}
                                    alt=""
                                /> */}
                                <div className="login_logo" style={{ width: "100%", height: "155px" }}>
                                    <div
                                        className="login_logo_img"
                                        style={{ height: "100%", width: "100%" }} />
                                </div>



                                {/* <h2 style={{ textAlign: "center" }}>{props.title}</h2> */}
                                {localStorage.getItem(Constants.localStorageConstants.company_name) === "UNITED"
                                    ? <div className="LoginTitle">
                                        <h6 className='WelcomeLoginAR' >مرحباً بكم في موقع التداول الإلكتروني لشركة المتحدة للأوراق المالية</h6>
                                        <h5 className='WelcomeLoginEN'>Welcome to UNITED SECURITIES Online Trading Portal</h5>
                                    </div> :
                                    localStorage.getItem(Constants.localStorageConstants.company_name) === "GLOBAL"
                                        ? <div className="LoginTitle">
                                            <h6 className='WelcomeLoginAR' >مرحباً بكم في موقع التداول الإلكتروني لشركة الدولية للأوراق المالية</h6>
                                            <h5 className='WelcomeLoginEN'>Welcome to GLOBAL FINANCIAL SECURITIES  Online Trading Portal</h5>
                                        </div> :
                                        <h5 className='WelcomeMessageDiv' style={{ textAlign: "center", marginTop: "30px", width: "100%" }}>{props.subTitle}</h5>
                                }

                                <div className='LoginFormContainer'>
                                    {props.form}
                                </div>
                                {/* <div>
                                    <Toggle theme={theme} toggleTheme={toggleTheme} />
                                </div> */}
                            </div>
                            {/* <div className="terms-use center">
                                <a className="terms-use-a" href="/#">{t("terms")}</a>
                            </div> */}

                            <div className="">
                                <div className="ImagesSlider">
                                    <ImagesSlider />
                                </div>
                            </div>
                        </div>

                    </div>


                </div>

            </>
        </ThemeProvider>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        setDarkMode: (isDarkMode) => {
            dispatch({
                type: actions.SET_DARK_MODE,
                payload: {
                    isDarkMode: isDarkMode
                }
            })
        },
    }
}

//export default connect(null, mapDispatchToProps)(withTranslation(null))(AuthContainer);
export default connect(null, mapDispatchToProps, null, { forwardRef: true })(withTranslation(null, { withRef: true })(AuthContainer));